"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailsSentMetricName = void 0;
exports.emailsSentMetricName = "emails-sent";
//# sourceMappingURL=emailSentMetricsHelper.js.map